import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "normalActions", "afterSelectActions", "link"]
  static values = { ids: { type: Array, default: [] }, param: String }

  checkAll(event) {
    this.inputTargets.forEach((input) => {
      if (!input.disabled) input.checked = event.currentTarget.checked
    })
    this.sync()
  }

  sync() {
    this.idsValue = this.inputTargets.filter((input) => input.checked).map((input) => input.value)
  }

  idsValueChanged() {
    this.refreshActions()
    this.refreshLinks()
  }

  refreshActions() {
    const active = this.idsValue.length > 0
    this.afterSelectActionsTarget.classList.toggle("hidden", !active)
    this.normalActionsTarget.classList.toggle("hidden", active)
  }

  refreshLinks() {
    this.linkTargets.forEach((link) => {
      const url = new URL(link.href)
      url.searchParams.delete(`${this.paramValue}[]`)
      this.idsValue.forEach((id) => url.searchParams.append(`${this.paramValue}[]`, id))
      link.href = url
    })
  }
}
